<template>
  <div>
    <div id="page" v-if="rendered.isNormal" style="z-index:-4">
      <div class="message-box"
           :style="{height: rendered.isNav ? '330px' : '300px',backgroundPosition: rendered.isNav ? '0 0' : '0 -15px'}">

        <div style="width:100%;" :style="{height: rendered.isNav ? '30px' : '1px'}"></div>
        <div style="text-align: left;padding: 0 20px;color: #fff">
          <div class="message-box-ItemTop">
            {{ rendered.operatorNickname }}
            <img class="message-box-icon" :src="require('../../assets/signal' + rendered.signalStrength + '.png')"
                 alt="获取数据失败">
          </div>
          <div class="message-box-msgItem">
            <img class="message-box-msgItem-icon" :src="require('../../assets/卡号.png')" alt="">
            卡号 : {{ required.sim }}
          </div>
          <div class="message-box-msgItem">
            <img class="message-box-msgItem-icon" :src="require('../../assets/iccid.png')" alt="">
            ICCID : {{ required.iccId }}
            <img style="width:15px;height:15px;margin-left: 5px" @click="copyIccId"
                 :src="require('../../assets/复制卡号.png')" alt="">
          </div>
          <div class="message-box-msgItem" :style="{color:rendered.statusColor}">
            <img class="message-box-msgItem-icon" :src="require('../../assets/时间.png')" alt="">
            结算日 : {{ rendered.expired }}
          </div>
          <div class="message-box-msgItem">
            <img class="message-box-msgItem-icon" :src="require('../../assets/状态.png')" alt="">
            状态 : {{ rendered.status }}
            <div class="diagnosis" @click="toIccidDetection" v-if="rendered.showDetection">
              <img :src="require('../../assets/智能诊断.png')" alt="">
              智能诊断
            </div>
          </div>

          <div class="message-box-main">
            <div class="message-box-main-tip">
              <van-icon name="replay" :class="{'rotating' : !rendered.loading }" @click="refresh"/>
              <!--              <van-loading type="spinner" size="18px" color="#0094ff" v-else/>-->
            </div>
            <div class="message-box-main-container">
              <div class="message-box-main-container-left">
                <span style="margin-bottom:10px">当前套餐</span>
                <span class="message-box-main-container-bold">
                {{ rendered.used }}
                </span>
              </div>
              <div style="margin:5px 0;width:1px;background: #85a4b4"></div>
              <div class="message-box-main-container-right" id="rightBox">
                <span style="margin-bottom:10px">{{ rendered.isUnlimitedUnit ? '剩余/总数' : '剩余/总量' }}</span>
                <span class="message-box-main-container-bold" v-if="!autoScroll" style="margin: 0 10px">
                  <span :style="{color:rendered.surplusColor}">
                    {{ rendered.used !== '-' ? rendered.surplus : '-' }}
                    {{ rendered.isUnlimitedUnit ? '天' : rendered.surplusUnit }}</span>
                  <span>/{{ rendered.used !== '-' ? rendered.total : '-' }}{{
                      rendered.isUnlimitedUnit ? '天' : 'G'
                    }}</span>
                </span>
                <span class="autoScrollBox" v-else>
                  <span class="autoScroll">
                    <span :style="{color:rendered.surplusColor}">
                      {{ rendered.used !== '-' ? rendered.surplus : '-' }}
                      {{ rendered.isUnlimitedUnit ? '天' : rendered.surplusUnit }}
                    </span>
                    <span>/{{ rendered.used !== '-' ? rendered.total : '-' }}{{
                        rendered.isUnlimitedUnit ? '天' : 'G'
                      }}</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 套餐列表-->
      <selectCards/>

      <div class="detail-introduce">
        <div style="display:flex;flex-direction: row;justify-content: space-between;flex-wrap: wrap;">
          <div class="detail-introduce-btn" @click="toUniversal">
            <img style="" :src="require('../../assets/其他卡号充值.png')" alt="">
            <span>其他卡号充值</span>
          </div>
          <div class="detail-introduce-btn" @click="toIssues">
            <img style="" :src="require('../../assets/充值问题反馈.png')" alt="">
            <span>充值问题反馈</span>
          </div>
        </div>
      </div>

      <div class="payment-box">
        <div style="text-align: left">
          <span style="font-size:12px">¥ </span>
          <span style="font-size:25px;font-weight:bold">{{ choosePlanStore.currentPrice }}</span>
          <br>
          <span style="font-size:12px;color:#FFB58E">
            {{ translateTitle("已优惠" + '¥' + choosePlanStore.discountedPrice) }}
          </span>
        </div>
        <div style="width: 78%;display:flex;justify-content: flex-start;flex-direction: row-reverse;">
          <van-button color="#46BCD5" style="margin-left:3%;border-radius: 5px;width: 45%;white-space: nowrap"
                      @click="submit('WX')"
                      :disabled="!choosePlanStore.productId" v-if="isShowPlatformId('WX')">
            <span style="vertical-align: sub;font-size: 14px;">
              <van-icon name="wechat-pay" color="#ffffff"/>
              微信支付
            </span>
          </van-button>
          <van-button color="#46BCD5" style="margin-left:5%;border-radius: 5px;width: 45%;white-space: nowrap;"
                      @click="submit('ALI')"
                      :disabled="!choosePlanStore.productId" v-if="isShowPlatformId('ALI')">
            <span style="vertical-align: sub;font-size: 14px;">
              <van-icon name="alipay" color="#ffffff"/>
              支付宝支付
            </span>
          </van-button>
        </div>
      </div>

      <monthlyDescription/>
    </div>
    <div v-else>
      <van-empty :description="translateTitle(rendered.description)" image-size="240px">
        <van-button :color="'#' + required.skin" @click="toUniversal">使用其他卡号充值</van-button>
      </van-empty>
    </div>
    <van-popup
        position="bottom"
        round
        safe-area-inset-bottom
        v-model:show="choosePlanStore.showAgreement">
      <div class="title">自动续费协议</div>
      <div class="content">
        <p>1. 服务条款的接受与修改</p>
        1.1 本协议是{{fourGFlowStore.currentCardMsg.appName}}会员（下称“会员”）与深圳市维拍物联智能技术有限公司 （下称“维拍”）之间关于会员使用{{fourGFlowStore.currentCardMsg.appName}}提供的自动续费委托扣款服务（下称“本服务”）所订立的协议，本协议描述维拍与会员之间关于本服务的使用及相关方面的权利义务。“会员”是指完成了成为维拍4G流量会员的全部程序，且在遵守维拍相关使用规则下使用维拍提供的会员服务的自然人。本协议构成会员使用维拍所提供的本服务之先决条件，维拍已经以字体加粗或其他合理方式提示会员重点阅读协议中相关免除或限制责任条款，双方确认前述条款不属于 《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利”条款，用户和维拍均认可其合法性及有效性。除非会员接受本协议条款，否则会员无权使用本服务，会员选择使用本服务行为将视为同意接受本协议各项条款的约束。
        <br/>
        1.2 维拍有权随时对服务条款进行修改一旦服务条款发生变更和修改，维拍将在相关页面上进行公告，且修改内容在公告之日的10日后生效和执行；如果会员不同意本协议的任一修改，可以取消自动续费功能；如果会员继续使用的，则视为会员已经接受本协议的全部修改。
        <br/>
        1.3 会员在使用本服务时须具备相应的权利能力和行为能力，能够独立承担法律责任，如果会员在18周岁以下，必须在父母或其他监护人的监护参与下才能使用本服务，其使用本服务的行为视为已获得了父母或其他监护人的认可。
        <p>2. 服务说明</p>
        2.1本服务是出于会员对于自动续费的需求，在会员已开通本服务的前提下，避免会员因疏忽或其他原因导致未能及时续费造成损失而推出的服务，会员授权维拍可在会员有效期即将过期时，委托支付渠道从会员的自有充值账户、与会员账号绑定的第三方支付账户、银行卡、通信账户（以下统称“账户”）余额中代扣下一个计费周期的费用，计费周期包括但不限于月度、季度、年度等（下同），会员可根据维拍平台上显示的计费周期自行选择。该服务实现的前提是会员已将其维拍会员账号与上述账户绑定，且可成功从其上述账户中扣款。
        <br/>
        2.2 自动续费具体指，基于2.1的前提，维拍通过上述账户收取会员下一计费周期费用的扣费方式，会员需保证维拍可以从上述账户扣款成功，因上述账户中可扣款余额不足导致的续费失败，由会员自行承担责任，维拍有权中断/终止相应的会员服务。
        <br/>
        2.3 会员选择开通自动续费，则视为同意授权维拍向账户发出扣款指令，并同意账户可以根据维拍发出的扣款指令，在不验证会员账户密码、支付密码、短信校验码等信息的情况下从账户中扣划下一个计费周期的费用。除非会员主动明确地取消了自动续费，否则，会员对维拍的自动扣款委托为不可撤销。除法律法规另有规定外，维拍不以任何方式对会员所支付的费用予以退还。
        <br/>
        2.4 会员在享受本服务时，应受《购买协议》《隐私政策》以及《用户协议》各项条款及相关子协议、页面说明或规范流程等全部内容的约束，当会员使用本服务时，会员的使用行为视为其对本服务的服务条款以及维拍针对本服务发出的各类公示的同意。本协议如与《用户协议》《购买协议》发生冲突的，以本协议为准。
        <br/>
        2.5 维拍向会员提供的本服务均仅限于会员在维拍平台使用，任何以恶意破解等非法手段将维拍提供的本服务与维拍平台分离的行为，均不属于本协议中约定的本服务。由此引起的一切法律后果由行为人负责，维拍将依法追究行为人的法律责任。
        <p>3.双方的权利和义务</p>
        3.1维拍负责向会员提供有关自动续费收费具体情况的查询方式，但不负责打印相关发票并/或转送会员。
        <br/>
        3.2 维拍将在会员有效期即将过期前以发送手机短信或其他方式向会员发送自动续费提示，通过会员上述账户扣除下一计费周期费用的，将在划扣当天将划扣款项记入会员支付记录，并同时相应延长会员有效期。一旦扣款成功，则维拍有权即时收取该费用，并不提供退费服务。
        <br/>
        3.3 如在扣费过程出现差错，维拍和会员应密切配合查明原因，各自承担己方过错造成的损失；若因双方各自存在不均等过错造成损失的，由双方按过错的程度承担相应责任；因双方共同过错造成损失但无法区分各自过错的，由双方均摊责任。
        <br/>
        3.4维拍可根据其业务开展或技术升级等情況变更或修改本协议的有关服务内容、规则及条款，维拍将通过在维拍相关页面或其他适当的位置进行公示的方式告知用户相关变更或修改内容，但无义务另行做个别通知。上述公示自维拍发送之日视为已送达用户，如多种通知方式并存的，则送达时间以上述方式中最早发送之时为准。如果会员不同意本协议的修改，可以取消已经获取的本服务并停止使用；如果会员继续使用维拍提供的服务，则视为会员已经接受本协议的全部修改。
        <br/>
        3.5 本服务由会员自主选择是否取消，若会员选择不取消，则视为会员同意维拍有权持续地按照一定规则进行不定期的扣款尝试一旦扣款成功，维拍将为会员开通下一个计费周期的会员服务。
        <br/>
        3.6 若在自动续费时/之前，维拍服务价格发生调整，应以扣款时维拍平台上公示的现时有效的价格为准
        <br/>
        3.7 维拍对会员开通本服务不收取任何额外手续费用，但维拍有权根据业务需要或市场变化等原因决定是否对本服务本身进行收费或调整自动续费周期及费用，并在相关页面向会员进行公示。
        <br/>
        3.8 会员在会员有效期内续费的，有效期将在原服务有效期基础上延长。
        <br/>
        3.9 会员理解并同意，会员授权维拍的代扣权限将视为会员本人的充值行为。如因此导致会员自身的任何损失，会员不会向维拍及其关联公司主张任何权利及追究任何责任。
        <p>4. 协议有效期限、终止</p>
        4.1 本协议自会员选择接受或使用本服务后生效，直至会员终止本服务/注销会员资格时终止，除非维拍另有公告。
        <br/>
        4.2 会员有权随时在会员账号设置中选择终止本服务，终止本服务后，维拍将停止向会员提供本服务
        <br/>
        4.3 会员在选择终止本服务前已经委托维拍自动续费扣款的指令仍然有效，维拍对于基于该指令已经扣除的费用不予退还，由会员承担相关责任与损失。
        <br/>
        4.4 维拍有权根据自身业务调整、价格变动等原因中止、终止本服务。一旦发生此种情形，维拍会以公告的方式通知会员。
        <p>5.违约责任</p>
        <span>如果一方违约，守约方有权通过双方约定的违约解决方式获得补偿或赔偿。</span>
        <p>6.争议解决和法律适用</p>
        <span>维拍与会员应通过友好协商解决本协议履行过程中产生的争议，经协商无法解决的，任何一方均有权将争议提交至深圳市南山区人民法院诉讼解决。本协议的解释、效力和执行等有关问题均适用中华人民共和国法律。</span>
        <p>7.其他</p>
        7.1如会员对本协议或使用维拍的自动续费服务相关的事宜有任何问题（包括问题咨询、投诉等）请通过功能页面的意见反馈入口或在线客服、app@vstarcam.com与维拍联系，维拍会在收到会员的意见、建议后尽快向会员回复。
        <br/>
        7.2本协议的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
        <br/>
        7.3 本协议于首页更新时间的10日后生效。

        <div style="margin-top: 24px;text-align:left">
          深圳市维拍物联智能技术有限公司<br />
          Copyright &copy;2022维拍 All Rights Reserved
        </div>

      </div>
      <van-button class="button" @click="onCancel" type="primary" round>同意并继续</van-button>
    </van-popup>
    <van-popup
        position="bottom"
        round
        safe-area-inset-bottom
        v-model:show="choosePlanStore.showAgreementDes">
      <div class="title">自动续费协议说明</div>
      <div>
        <van-cell-group>
          <img class="cell-icon" :src="require('../../assets/3.png')" alt="获取数据失败">
          <van-cell center title="续费时间" label="订单到期日自动续费，可随时取消该功能" />
        </van-cell-group>
        <van-cell-group>
          <img class="cell-icon" :src="require('../../assets/2.png')" alt="获取数据失败">
          <van-cell title="续费产品" label="原产品原方案" />
        </van-cell-group>
        <van-cell-group>
          <img class="cell-icon" :src="require('../../assets/1.png')" alt="获取数据失败">
          <van-cell title="续费方式" label="默认续费方式与本次付款方式相同" />
        </van-cell-group>
        <van-cell-group>
          <img class="cell-icon" :src="require('../../assets/4.png')" alt="获取数据失败">
          <van-cell title="生效日期" label="续费成功，到期后进行自动续费扣款" />
        </van-cell-group>
      </div>
      <van-button class="button" :class="{'is-disabled': isDisabled}" @click="submit('other')" round>{{ btnTime!==0 ? `请先阅读续费协议说明(${btnTime}s)` : '立即开通' }}</van-button>
    </van-popup>
  </div>
</template>

<script>
import {translateTitle} from "@/utils/i18n";
import {reactive, toRefs, defineAsyncComponent, onMounted, nextTick, computed, ref} from "vue";
import {storage, refreshCard, searchDeviceCard,} from "@/api"
import router from "@/router";
import {Toast} from 'vant'
import {useFourGFlowStore, useRenderedParamsStore} from "@/store/modules/FourGFlow";
import {useChoosePlanStore} from "@/store/modules/ChoosePlan";
import {
  getSkin,
  setUrlParam,
  getUrlParam,
  getUrlAllParam,
  setLocalParam,
  mapURLParameters,
} from '@/utils/tool'
import {getCardInfo} from "@/api/baseEntry";

export default {
  name: "index",
  components: {
    selectListItem: defineAsyncComponent(() => import('@/components/selectListItem')),
    selectCards: defineAsyncComponent(() => import('@/components/selectCards')),
    monthlyDescription: defineAsyncComponent(() => import('@/components/monthlyDescription'))
  },
  setup() {
    const fourGFlowStore = useFourGFlowStore()
    const choosePlanStore = useChoosePlanStore()
    const rendered = useRenderedParamsStore()
    //必要参数
    let {defaultParams: required} = fourGFlowStore
    const state = reactive({autoScroll: false,btnTime:3, isDisabled:true})
    const toIssues = () => routerChange('/Issues', '')
    const toUniversal = () => routerChange('/Universal', '')
    const toIccidDetection = () => routerChange('/intelligentDetection', {iccId: required.iccId})

    const routerChange = (path, params) => {
      if (required.scenes === 'APP') {
        const url = setUrlParam(path, params)
        fourGFlowStore.webViewBridge.newPage(url)
      } else router.push({path: path})
    }
    // 复制卡号
    const copyIccId = async () => {
      let aux = document.createElement("input");
      aux.setAttribute("value", required.iccId);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      Toast('复制成功');
    }
    //初始化参数
    const init = () => {
      //查询URL参数
      const opt = getUrlAllParam()
      console.warn('home-页面URL传参', opt)
      //映射URL参数
      mapURLParameters(required, opt, () => {
        console.warn('页面参数映射完成,网站当前rgb', required.rgb)
        //记录访问首页URL
        setLocalParam('homeUrl', window.location.href)
        setLocalParam('home', opt)
        rendered.home = opt
        //参数对齐
        const {rgb: ord_url_rgb, oemId: url_oemId, oemid: url_oemid} = opt
        const url_rgb = decodeURIComponent(ord_url_rgb)
        //特殊oemId处理(福莱赋)
        required.oemId = url_oemId || url_oemid || required.oemId
        if (required.oemId === 'LAICAM') required.oemId = 'FLFDZ'
        //页面皮肤
        console.warn('页面皮肤设置前', required.skin)
        if (url_rgb && url_rgb !== 'undefined') required.skin = getSkin(url_rgb)
        console.warn('页面皮肤设置后', required.skin)
      })
    }

    const check = async (iccid) => {
      if (iccid.indexOf('8986') !== 0) {
        rendered.unSupport('未知卡')
        throw new Error('未知卡')
      }
      const len_start = iccid.length
      if (len_start < 19 || len_start > 20) {
        rendered.unSupport('未知卡')
        throw new Error('未知卡')
      }
      // 查询卡是新卡还是旧卡
      const data = {iccid}
      const res = await getCardInfo(data)
      if (res.type === '自营4G流量卡') {
        console.log('跳转')
        window.location.replace(`https://m.eye4.cn/s056/index?iccId=${iccid}`)
        throw new Error('跳转页面')
        // return
      } else {
        console.log('不跳转')
      }
    }

    const submit = (channel) => {
      if(channel === 'WX'){
        choosePlanStore.fourGtoPay('WX')
      }else if(channel === 'ALI'){
        choosePlanStore.fourGtoPay('ALI')
      }else{
        if(state.btnTime !== 0) return
        choosePlanStore.onSubmit()
      }
    }

    //业务逻辑
    const business = async () => {
      // 校验关键参数
      if (!required.iccId) return toUniversal()
      //参数完整，校验通过
      console.warn('参数完整，已通过验证')
      await check(required.iccId)
      //查询卡信息
      await rendered.showCardInfo()
      // 渲染产品
      await rendered.renderProduct()
      //显示套餐
      await rendered.showComboList(rendered.isActive)
      //设置导航栏右侧订单按钮数据
      await fourGFlowStore.webViewBridge.setRightNavData(required.iccId, required.scenes, required.skin, required.oemId, required.H5pay)

    }
    //刷新页面数据
    const refresh = async () => {
      console.warn('刷新页面数据')
      const {iccId, platformId} = required
      rendered.loading = false
      //设备信号强度
      fourGFlowStore.webViewBridge.deviceSignalStrength(required.iccId, (signalStrength) => {
        console.warn('当前信号值--->', signalStrength)
        rendered.signalStrength = signalStrength
      })
      //刷新卡信息
      await refreshCard(platformId, iccId)
      console.warn('已刷新卡信息')
      // 解决页面闪动问题
      rendered.used = '-'
      //重新加载卡信息
      await rendered.showCardInfo()
      //取消刷新动画
      rendered.loading = true
    }
    // 对App获取 100% did 利用did获取iccId
    const getDid = () => {
      return new Promise((resolve, reject) => {
        fourGFlowStore.webViewBridge.getDeviceId(async (did) => {
          console.warn("获取did", did)
          if (!did) rendered.unSupport('获取设备id异常')
          const {iccId} = await searchDeviceCard(did)
          console.warn("获取iccid", iccId)
          return resolve(iccId)
        })
      })
    }
    // 动态判断是否有多平台支付，部分套餐仅支持支付宝
    const isShowPlatformId = computed(() => (platform) => {
      if (platform === 'WX' &&
          choosePlanStore.selectedCombo &&
          choosePlanStore.selectedCombo.group === 'automatic_renewal') {
        return false
      } else if (platform === 'ALI' && required.oemId === 'COOCAM') {
        return false
      }
      return true
    })

    const onCancel = () => {
      choosePlanStore.showAgreement = false
      choosePlanStore.showAgreementDes = true
      state.isDisabled = true
      state.btnTime = 3
      const timer = setInterval(()=> {
        state.btnTime--
        if(state.btnTime === 0) {
          clearInterval(timer)
          state.isDisabled = false
        }
      }, 1000)
    }

    nextTick(() => {
      console.log(document.getElementById("rightBox").offsetWidth, "width======");
      if (document.getElementById("rightBox").offsetWidth > 230) state.autoScroll = true
    })
    // 仅为获取iccid若获取成功则进行业务处理
    const process = async () => {
      console.warn("清除缓存前:", required)
      required.iccId = ''
      console.warn("清除缓存后:", required)
      // 初始化
      await fourGFlowStore.initBridge()
      choosePlanStore.initData('4G流量商城')
      await init()
      const {scenes} = required
      console.warn('查看当前环境', required)        //检测环境
      if (scenes === 'H5') return await business()          //业务逻辑
      else if (scenes !== 'APP') return rendered.unSupport('应用开发中，敬请期待')

      //加载APP关键参数
      await fourGFlowStore.webViewBridge.reloadRequired(async (data) => {
        console.warn('APP关键参数', data)
        // 调用日志接口，进行记录
        storage(data.userId, data.iccId || "iccid缺失", JSON.stringify(data))
        //APP参数校准
        const {iccId: app_iccId, userId: app_userId, language: app_language} = data
        if (app_userId) required.userId = app_userId
        if (app_language) required.language = app_language
        // 若从路由中获取不到参数则直接调用接口获取该设备 iccId (经商讨不使用app_iccId)
        required.iccId = getUrlParam('iccId') || getUrlParam('iccid') || await getDid()
        await business() //业务处理
      })
    }

    process()

    return {
      ...toRefs(state),
      required,
      rendered,
      translateTitle,
      router,
      fourGFlowStore,
      choosePlanStore,
      refresh,
      toUniversal,
      toIssues,
      copyIccId,
      isShowPlatformId,
      toIccidDetection,
      submit,
      onCancel
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  padding-top: 10px;
  transition: .3s;
}

.message-box {
  background: url('../../../public/img/4Gbg.png') no-repeat;
  background-size: cover;
  height: 375px;
  width: 100%;
  border-radius: 0 0 50% 50% / 0 0 15% 15%;
  position: relative;
  overflow: hidden;
  z-index: 0;

  &::before {
    content: '';
    background: url('../../../public/img/4Gbg(2).png') no-repeat center;
    width: 155px;
    height: 180px;
    top: calc(50% - 150px);
    right: -40px;
    position: absolute;
    background-size: cover;
    z-index: -1;
  }

  //background-position-y: -10x;
  &-ItemTop {
    height: 22px;
    font-size: 22px;
    letter-spacing: 2px;
    margin: 15px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start
  }

  &-icon {
    width: 20px;
    margin-left: 10px;
  }

  &-msgItem {
    margin-bottom: 10px;
    font-size: 14px;
    color: #eeeeee;
    display: flex;
    flex-direction: row;
    align-items: center;

    &-icon {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }

  &-main {
    background: rgba(255, 255, 255, 0.8);
    width: 100%;
    height: 135px;
    border-radius: 15px;
    text-align: right;
    position: relative;
    margin-top: 15px;

    &-container {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 100%;
      color: #255BAB;
      margin-top: 10px;

      &-left, &-right {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        //width: 50%;
        align-items: center;
        font-size: 14px;
        letter-spacing: 1px;
        max-width: 65%;
        min-width: 35%;

        span:nth-of-type(2) {
          font-weight: bold;
        }
      }

      &-bold {
        font-size: 20px;
      }
    }

    &-tip {
      color: #fff;
      background: linear-gradient(to right, #50D6F4, #29AAFB);
      border-radius: 0 15px;
      font-size: 17px;
      width: 30px;
      text-align: center;
      padding: 5px 15px;
      display: inline-block;
      min-height: 14px;
    }
  }
}

.p-i-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.title-left-box, .title-right-box {
  margin: 0 10px;
  display: inline-block;
  width: 23%;
  height: 3px;
  background: linear-gradient(to right, rgb(255, 255, 255), #B7914C)
}

.title-right-box {
  background: linear-gradient(to right, #B7914C, rgb(255, 255, 255))
}

.detail-introduce {
  padding: 0 20px;
  font-size: 14px;
  color: #bdbdbd;
  text-align: left;
  margin-bottom: 100px;

  &-btn {
    border-radius: 10px;
    border: 1px solid #F0F0F0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 10px;
    width: fit-content;
    height: fit-content;
    font-size: 13px;
    color: black;
    margin-top: 10px;

    img {
      height: 40px;
    }

    span {
      margin-left: 10px
    }
  }
}

.payment-box {
  width: calc(100% - 40px);
  padding: 20px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0 -2px 6px 0 #7c7c7c1f;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.canScrollBox {
  //overflow-x: scroll;
  display: flex;
  flex-direction: row;
  //max-width: 90%;
  overflow: hidden;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.autoScrollBox {
  overflow: hidden;
  width: 80%;
  position: relative;
}

.autoScroll {
  position: relative;
  width: max-content;
  animation: move 3.5s ease-in-out infinite;
  padding: 0 10px;
  font-size: 20px;
  display: inline-block;
}

.diagnosis {
  background: linear-gradient(to bottom, #0F94FF, #227EFF);
  padding: 2px 6px;
  border-radius: 4px;
  box-shadow: 0 0 6px 0 #0000000d;
  right: 44%;
  display: flex;
  align-items: center;
  margin-left: 10px;

  img {
    width: 13px;
    margin-right: 5px
  }
}


.title{
  font-weight: bold;
  padding: 10px 0 10px 20px;
  border-bottom: 1px solid #eee;
}

.content {
  padding: 1px 16px 16px;
  height: 50vh;
  overflow: scroll;
}

.button {
  background: linear-gradient(45deg, #50f9da, #08b9dd);
  color: #fff;
  display: block;
  margin: 10px 10px 20px 10px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
}
.is-disabled{
  background: #d4d4d4;
}
.van-action-sheet {

   :deep(.van-action-sheet__header) {
    text-align: left;
    font-width: bold;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
  }
}

:deep(.van-cell__title, .van-cell__value) {
  padding-left: 30px;
}

.cell-icon{
  position: absolute;
  z-index: 1;
  left: 2%;
  top: 25%;
  width: 30px;
}


@keyframes move {
  0% {
    transform: translateX(0);
  }
  80% {
    transform: translateX(calc(-25%));
  }
  100% {
    transform: translateX(0);
  }
}

.rotating {
  animation: beggingRotate 1s infinite;
}

@keyframes beggingRotate {
  100% {
    transform: rotate(360deg);
  }
}

</style>